import React from 'react'

const Html = ({ as, children, ...props }) => {
  const Tag = as

  return <Tag dangerouslySetInnerHTML={{ __html: children }} {...props} />
}

export default Html
